import React from 'react';
import reframe from 'nike-re-framejs';

class HeaderTitleSetter extends React.Component {
    componentDidMount() {
        reframe.dispatch(['ui.setHeaderTitle', this.props.title]);
    }

    componentDidUpdate() {
        reframe.dispatch(['ui.setHeaderTitle', this.props.title]);
    }

    render() {
        return null;
    }
}

export default HeaderTitleSetter;
